module.exports = __webpack_public_path__ + "static/img/智能报账.4c6426ce.png";